"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

interface FaqItem {
	question: string;
	answer: string;
}

interface PdpFaqInlineProps {
	faq: FaqItem[];
}

export function PdpFaqInline({ faq }: PdpFaqInlineProps) {
	const [openIdx, setOpenIdx] = useState<number | null>(0);

	return (
		<div>
			{faq.map((item, idx) => {
				const open = openIdx === idx;
				return (
					<div key={item.question} className="border-t border-border py-4">
						<button
							type="button"
							onClick={() => setOpenIdx(open ? null : idx)}
							className="flex w-full items-center justify-between gap-3 text-left"
							aria-expanded={open}
						>
							<h4 className="text-base font-semibold text-foreground">{item.question}</h4>
							<ChevronDown
								className={cn(
									"h-4 w-4 shrink-0 text-muted-foreground transition-transform",
									open && "rotate-180",
								)}
								strokeWidth={2}
								aria-hidden
							/>
						</button>
						<div
							className={cn(
								"grid overflow-hidden transition-[grid-template-rows] duration-300 ease-in-out",
								open ? "mt-2.5 grid-rows-[1fr]" : "grid-rows-[0fr]",
							)}
						>
							<div className="overflow-hidden">
								<p className="text-foreground/85 text-sm leading-relaxed">{item.answer}</p>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}
